// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vmehCI {
  display: flex;
  align-items: center;
  gap: 12px;
  font-family: var(--font-family-base, 'Source Sans 3, sans-serif');
}

.PBDBl_ {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-self: stretch;
  min-height: 40px;
}

.A0HMLj {
  font-size: 12px;
  font-weight: 400;
  line-height: 1.424;
  color: var(--header-balance-text-color);
  margin: 0;
  width: 67px;
  height: 16px;
}

.owPtYl {
  font-size: 12px;
  font-weight: 600;
  line-height: 1.424;
  color: var(--header-balance-text-color);
  margin: 0;
  height: 16px;
  min-width: 80px;
}

.uZv7ws {
  display: flex;
  align-items: center;
  gap: 4px;
  width: 80px;
  height: 16px;
}

.YwIvlz {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: var(--header-balance-dot-color);
}

.AwZoUM {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  width: auto;
  height: 32px;
  border: none;
  border-radius: 4px;
  background: transparent;
  cursor: pointer;
  color: var(--header-balance-text-color);
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/HeaderBalance/HeaderBalance.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iEAAiE;AACnE;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,uCAAuC;EACvC,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,uCAAuC;EACvC,SAAS;EACT,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,uCAAuC;AACzC","sourcesContent":[".container {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-family: var(--font-family-base, 'Source Sans 3, sans-serif');\n}\n\n.section {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-self: stretch;\n  min-height: 40px;\n}\n\n.label {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 1.424;\n  color: var(--header-balance-text-color);\n  margin: 0;\n  width: 67px;\n  height: 16px;\n}\n\n.value {\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.424;\n  color: var(--header-balance-text-color);\n  margin: 0;\n  height: 16px;\n  min-width: 80px;\n}\n\n.hiddenValue {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  width: 80px;\n  height: 16px;\n}\n\n.dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background-color: var(--header-balance-dot-color);\n}\n\n.button {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  width: auto;\n  height: 32px;\n  border: none;\n  border-radius: 4px;\n  background: transparent;\n  cursor: pointer;\n  color: var(--header-balance-text-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `vmehCI`,
	"section": `PBDBl_`,
	"label": `A0HMLj`,
	"value": `owPtYl`,
	"hiddenValue": `uZv7ws`,
	"dot": `YwIvlz`,
	"button": `AwZoUM`
};
module.exports = ___CSS_LOADER_EXPORT___;
